import { apiClient } from "lib/apiClient";
import { IResearchWorkItem } from "features/Research/types";

export const restoreResearchDemand = async (
  workItemId: string,
  demandId: string,
  version: number
): Promise<IResearchWorkItem> => {
  const response = await apiClient.delete(
    `/research/work-items/${workItemId}/demands/${demandId}/cancellation`,
    { params: { version } }
  );
  return response.data;
};
